import React from "react";
import { motion } from "framer-motion";
import "./index.css";

const IconGrid = ({ iconUrls }) => {
  return (
    <div className="icon-grid">
      {iconUrls.map((url, index) => (
        <div key={index} className="icon-item">
          <motion.div
            drag
            dragConstraints={{
              top: -100,
              left: -80, 
              right: 100, 
              bottom: 100, 
            }}
            whileHover={{ scale: 1.1 }} 
            whileTap={{ scale: 0.9 }} 
            style={{ position: "relative", overflow: "hidden" }}
          >
            <img src={url} alt={`icon-${index}`} className="icon-image" />
          </motion.div>
        </div>
      ))}
    </div>
  );
};

export default IconGrid;
